export enum RemoteConfigKey {
  ASSET_RECOMMENDATION_ENABLED = 'ASSET_RECOMMENDATION_ENABLED',
  MIN_APP_VERSION = 'MIN_APP_VERSION',
  FIREBASE_AUTH_FALLBACK_ENABLED = 'FIREBASE_AUTH_FALLBACK_ENABLED', // temp key to enable phone auth through firebase as a fallback
  VIDEO_PLAYER_SCREEN_FIT = 'VIDEO_PLAYER_SCREEN_FIT',
  ENABLE_SIGN_OUT_ALL_DEVICES = 'ENABLE_SIGN_OUT_ALL_DEVICES',
}
